import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Registra a tu equipo para el torneo.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Tu serás el capitán del equipo, Amon Sûl te añadirá automáticamente a tu equipo. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Jugadores seleccionados:", -1)

import { ref, computed, onMounted } from "vue";
import { useAuth } from "@/composables/useAuth";
import { registrarEquipo } from "@/services/InscripcionesService";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import { InscripcionEquipoDTO } from "@/interfaces/Inscripcion";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalRegistroEquipo',
  props: {
    isVisible: { type: Boolean },
    tipoTorneo: {},
    idTorneo: {}
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const teamName = ref("");
const jugadorSelected = ref<UsuarioSinEquipoDTO | null>(null);
const jugadores = ref<UsuarioSinEquipoDTO[]>([]);
const selectedPlayers = ref<UsuarioSinEquipoDTO[]>([]);
const idsSelected = ref<number[]>([]);
const isRegistering = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const snackBarShow = ref<boolean>(false);
const snackBarMessage = ref<string>("");
const snackBarTimeOut = ref<number>(3000);
const loading = ref<boolean>(false);

const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string | null>(getidUsuario.value);

const maxPlayers = computed(() => {
  return props.tipoTorneo === "Parejas"
    ? 2
    : props.tipoTorneo === "Equipos_4"
    ? 4
    : props.tipoTorneo === "Equipos_6"
    ? 6
    : 0;
});

const dialogVisible = computed({
  get: () => props.isVisible,
  set: (value) => emit("update:isVisible", value),
});

const addPlayer = (player: UsuarioSinEquipoDTO) => {
  if (
    !player ||
    typeof player === "string" ||
    !player.idUsuario ||
    !player.nick
  ) {
    jugadorSelected.value = null;
    return;
  }

  if (
    player &&
    !selectedPlayers.value.some((p) => p.idUsuario === player.idUsuario)
  ) {
    if (selectedPlayers.value.length >= maxPlayers.value - 1) {
      snackBarMessage.value = `Solo puedes añadir un máximo de ${
        maxPlayers.value - 1
      } jugadores.`;
      snackBarShow.value = true;
      jugadorSelected.value = null;
      return;
    }
    selectedPlayers.value.push(player);
    idsSelected.value.push(player.idUsuario);
  }
  jugadorSelected.value = null;
};

const removePlayer = (index: number) => {
  selectedPlayers.value.splice(index, 1);
  idsSelected.value.splice(index, 1);
};

const validateForm = () => {
  if (!teamName.value.trim()) {
    snackBarMessage.value = "El nombre del equipo es obligatorio";
    snackBarShow.value = true;
    return false;
  }
  if (!props.idTorneo) {
    showErrorModal.value = true;
    return false;
  }
  return true;
};

const submitForm = async () => {
  if (!validateForm()) return;
  if (props.idTorneo && idUsuarioLogger.value) {
    const id = parseInt(idUsuarioLogger.value);
    const inscripcionEquipo: InscripcionEquipoDTO = {
      idTorneo: props.idTorneo,
      idCapitan: id,
      nombreEquipo: teamName.value,
      miembros: idsSelected.value,
      idInscripcion: 0,
      idUsuario: 0,
      idEquipo: 0,
      idOrganizador: 0,
      emailOrganizador: "",
      componentesEquipoDTO: [],
    };
    try {
      isRegistering.value = true;
      await registrarEquipo(inscripcionEquipo);
      showSuccessModal.value = true;
      emit("update:isVisible", false);
      window.location.reload();
    } catch (error) {
      showErrorModal.value = true;
    } finally {
      isRegistering.value = false;
    }
  } else {
    showErrorModal.value = true;
  }
};

const closeDialog = () => {
  emit("update:isVisible", false);
  teamName.value = "";
  selectedPlayers.value = [];
  idsSelected.value = [];
};

onMounted(async () => {
  loading.value = true;
  try {
    const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
      props.idTorneo
    );
    jugadores.value = (responseJugadores?.data ?? []).sort(
      (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
    );
  } catch (error) {
    console.error("Error al obtener jugadores: ", error);
    jugadores.value = [];
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_ModalSuccess = _resolveComponent("ModalSuccess")!
  const _component_ModalError = _resolveComponent("ModalError")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Registrar Equipo")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("p", null, "Debes añadir un máximo de " + _toDisplayString(maxPlayers.value - 1) + " participantes.", 1),
                _hoisted_2,
                _createVNode(_component_v_text_field, {
                  modelValue: teamName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((teamName).value = $event)),
                  label: "Nombre del equipo",
                  tonal: "",
                  required: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      modelValue: jugadorSelected.value,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((jugadorSelected).value = $event)),
                        addPlayer
                      ],
                      items: jugadores.value,
                      "item-title": "nick",
                      "item-value": "idUsuario",
                      label: "Selecciona un jugador",
                      tonal: "",
                      required: "",
                      "return-object": true,
                      "allow-new": false,
                      loading: loading.value
                    }, null, 8, ["modelValue", "items", "loading"]),
                    (loading.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "primary",
                          height: "2",
                          class: "mt-1"
                        }))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", null, [
                      _hoisted_3,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPlayers.value, (player, index) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: player.idUsuario,
                          closable: "",
                          "onClick:close": ($event: any) => (removePlayer(index)),
                          class: "ma-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(player.nick), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick:close"]))
                      }), 128))
                    ], 512), [
                      [_vShow, selectedPlayers.value.length]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "primary",
                  onClick: submitForm,
                  disabled: isRegistering.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Registrar equipo")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "secondary",
                  onClick: closeDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cerrar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Equipo registrado con éxito.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(_component_ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido registrar el equipo. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(_component_v_dialog, {
      modelValue: isRegistering.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isRegistering).value = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: "d-flex justify-center align-center",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "blue-lighten-3",
                  size: 57
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      color: "red-darken-2",
      timeout: snackBarTimeOut.value,
      modelValue: snackBarShow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((snackBarShow).value = $event)),
      eager: "",
      "auto-height": ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackBarMessage.value), 1)
      ]),
      _: 1
    }, 8, ["timeout", "modelValue"])
  ], 64))
}
}

})